import { Component } from '@angular/core';
import { SysconfigService } from '../../services/sysconfig.service';
import { LoaddingService } from '../../providers/loadding.service';

/*
  追号页面
  TQQ 2017-01-11
*/

@Component({
  selector: 'page-weixin',
  templateUrl: 'weixin.html',
  providers:[
    SysconfigService
  ]
})
export class WeiXinPage {
  qrcode: any;
  constructor(
    private sysService: SysconfigService,
    private loading: LoaddingService
  ) { }
    ngOnInit(): void {

      this.getkefuqecode();
    }
  //获取客服二维码地址
  getkefuqecode() {
    let load = this.loading.showLoding();
    this.sysService.getkefuqrcode().then(s => {
      if (s) {
        this.qrcode = s[0].ImgCode;
        this.loading.closeLoading(load);
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/weixin.ts